import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody, Label } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import { Formik } from 'formik';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import { lotCloneValidationSchema } from '~/validation/lot';

export const cloneLotsMutation = gql`
  mutation cloneLots($breweryId: Int!, $startDate: String!, $lotIds: [Int!]) {
    cloneLots(breweryId: $breweryId, startDate: $startDate, lotIds: $lotIds) {
      id
    }
  }
`;

const CloneLotsForm = ({ handleSubmit, onCancelClick, lots, errors, isSubmitting }) => (
  <form onSubmit={handleSubmit}>
    <ModalBody>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <div className="mb3">
        <Label>What's the brew date for these cloned lots?</Label>
        <FormikInputField type="date" name="startDate" invalid={!!errors.startDate} />
        {errors.startDate && (
          <p data-qa="startDate-error" className="error">
            {errors.startDate}
          </p>
        )}
      </div>
      <Label>Lots to clone:</Label>
      <table className="table mb0">
        <tbody>
          {lots.map(l => (
            <tr key={l.id}>
              <td>
                <strong>{l.reference}</strong>
              </td>
              <td>{l.volume}L</td>
              <td>
                <em>{l.product.name}</em>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancelClick}>
        Cancel
      </Button>{' '}
      <SubmissionButton type="submit" color="primary" isSubmitting={isSubmitting}>
        Clone
      </SubmissionButton>
    </ModalFooter>
  </form>
);

export class CloneLotsModal extends Component {
  state = {
    error: null
  };
  render() {
    const { lots, isOpen, onToggle, onSuccess, brewery } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Start brewing these lots</ModalHeader>
        <Mutation mutation={cloneLotsMutation}>
          {cloneLots => (
            <Formik
              validationSchema={lotCloneValidationSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={async (values, { setErrors, setSubmitting }) => {
                try {
                  await cloneLots({
                    variables: {
                      breweryId: brewery.id,
                      startDate: values.startDate,
                      lotIds: lots.map(l => l.id)
                    },
                    awaitRefetchQueries: true,
                    refetchQueries: ['lots']
                  });
                  onSuccess();
                } catch (err) {
                  setErrors({
                    unknown: 'An unknown error occured'
                  });
                  setSubmitting(false);
                }
              }}
              render={props => (
                <CloneLotsForm
                  {...props}
                  brewery={brewery}
                  lots={lots}
                  onCancelClick={onToggle}
                  onSuccess={onSuccess}
                />
              )}
            />
          )}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(CloneLotsModal);



// WEBPACK FOOTER //
// ./src/containers/cloneLotsModal/cloneLotsModal.jsx